var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-end": "" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "mb-2",
          attrs: { slot: "activator", outline: "", color: "primary" },
          on: { click: _vm.open },
          slot: "activator"
        },
        [
          _c("v-icon", { attrs: { dark: "", left: "" } }, [_vm._v("note_add")]),
          _vm._v("New Item\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1000px" },
          model: {
            value: _vm.localDialog,
            callback: function($$v) {
              _vm.localDialog = $$v
            },
            expression: "localDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.formTitle))
                ])
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Name",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "name", $$v)
                                      },
                                      expression: "local.name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    attrs: { label: "Description(Optional)" },
                                    model: {
                                      value: _vm.local.description,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "description", $$v)
                                      },
                                      expression: "local.description"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.typeOfLights,
                                      label: "Type of Light",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.typeOfLight,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "typeOfLight", $$v)
                                      },
                                      expression: "local.typeOfLight"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.shadowTypes,
                                      label: "Select Shadow Type",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.shadowType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "shadowType", $$v)
                                      },
                                      expression: "local.shadowType"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Duration (sec)",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.duration,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "duration", $$v)
                                      },
                                      expression: "local.duration"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Target", type: "text" },
                                    model: {
                                      value: _vm.local.target,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "target", $$v)
                                      },
                                      expression: "local.target"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Range", type: "number" },
                                    model: {
                                      value: _vm.local.range,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "range", $$v)
                                      },
                                      expression: "local.range"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Intensity", type: "text" },
                                    model: {
                                      value: _vm.local.intensity,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "intensity", $$v)
                                      },
                                      expression: "local.intensity"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Shadow Strength",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.local.shadowStrength,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "shadowStrength",
                                          $$v
                                        )
                                      },
                                      expression: "local.shadowStrength"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("h3", [_vm._v("Position of Origin")]),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Position of Origin Dimension X",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.positionOfOrigin.X,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local.positionOfOrigin,
                                          "X",
                                          $$v
                                        )
                                      },
                                      expression: "local.positionOfOrigin.X"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Position of Origin Dimension Y",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.positionOfOrigin.Y,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local.positionOfOrigin,
                                          "Y",
                                          $$v
                                        )
                                      },
                                      expression: "local.positionOfOrigin.Y"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Position of Origin Dimension Z",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.positionOfOrigin.Z,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local.positionOfOrigin,
                                          "Z",
                                          $$v
                                        )
                                      },
                                      expression: "local.positionOfOrigin.Z"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Rotation of Origin")]),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Rotation of Origin Dimension X",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.rotationOfOrigin.X,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local.rotationOfOrigin,
                                          "X",
                                          $$v
                                        )
                                      },
                                      expression: "local.rotationOfOrigin.X"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Rotation of Origin Dimension Y",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.rotationOfOrigin.Y,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local.rotationOfOrigin,
                                          "Y",
                                          $$v
                                        )
                                      },
                                      expression: "local.rotationOfOrigin.Y"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Rotation of Origin Dimension Z",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.rotationOfOrigin.Z,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local.rotationOfOrigin,
                                          "Z",
                                          $$v
                                        )
                                      },
                                      expression: "local.rotationOfOrigin.Z"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", outline: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.save } },
                    [
                      this.saving
                        ? _c(
                            "v-flex",
                            [
                              _c("v-progress-circular", {
                                attrs: { indeterminate: "", color: "primary" }
                              })
                            ],
                            1
                          )
                        : _c("v-flex", [_vm._v("Save")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-212ae636", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-212ae636","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/add-new/addLighting.vue
// module id = null
// module chunks = 